import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

import * as S from './styles';

export default function AuthLayout() {
  const history = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/auth') history('/auth/login');
  }, [history, location.pathname]);

  return (
    <S.Container>
      <S.PagesContent>
        <S.FormSlot>
          <S.Card>
            <Outlet />
          </S.Card>
        </S.FormSlot>
      </S.PagesContent>

      <S.LayoutContent>
        <S.ColorBack />
        <S.FadeTopRight />
        <S.FadeBottomLeft />
        <S.LogoContent>
          <S.Logo src="/logos/logo-main-white.png" alt="Frontline Solutions" />
          <S.WelcomeInfo>
            <S.LockIcon src="/images/lock-icon.svg" alt="" />
            <S.Title>WELCOME TO FRONTLINE</S.Title>
          </S.WelcomeInfo>
        </S.LogoContent>
      </S.LayoutContent>
    </S.Container>
  );
}
